import React from 'react';
import { Button } from "react-bootstrap";
import { Form } from 'react-bootstrap';
const StepTwo = ({ setActiveStep }) => {
    return (
        <>
            <div className="row justify-content-center">
                <div className="col-xl-9">
                    <div className="card custom-card">
                        <div className="card-body">
                            <h5 className="text-center">Driver’s License Information</h5>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Driver’s License Number:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Driver’s License Number" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>State of Issuance:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter State of Issuance" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>License Class:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter License Class" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Status:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Status" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Restrictions:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Restrictions" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Endorsements:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Endorsements" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Issue Date:</Form.Label>
                                                <Form.Control type="date" placeholder="Enter Issue Date" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Expiration Date:</Form.Label>
                                                <Form.Control type="date" placeholder="Enter Expiration Date" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Upload Front Copy of Driver's License:</Form.Label>
                                                <Form.Control type="file" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Upload Back Copy of Driver's License:</Form.Label>
                                                <Form.Control type="file" />
                                            </Form.Group>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 d-flex mb-3">
                                    <Button
                                        variant="secondary"
                                        className="mt-auto w-100"
                                        onClick={() => setActiveStep(0)}
                                    >
                                        Previous
                                    </Button>
                                </div>
                                <div className="col-lg-3 d-flex mb-3">
                                    <Button
                                        variant="primary"
                                        className="text-white mt-auto w-100"
                                        onClick={() => setActiveStep(2)}
                                    >
                                        Next
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default StepTwo;
